import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { resolveImageUrl } from "../../lib/SettingsContext";

function Icon({ name, className }) {
  const Cmp = Icons[name] || Icons.Printer;
  return <Cmp className={className} />;
}

export default function Services({ items, onQuoteClick }) {
  return (
    <section id="services" className="py-24 bg-brand-mist">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="overline text-brand-green">Our Services</div>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold text-brand-ink leading-tight tracking-tight">
              Everything you'll ever print, <span className="text-brand-blue">in one studio.</span>
            </h2>
          </div>
          <button onClick={onQuoteClick} data-testid="services-quote-btn" className="btn-secondary self-start md:self-auto">
            Request a Quote
          </button>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {items.map((s, i) => {
            const img = resolveImageUrl(s.image_url);
            return (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.45, delay: (i % 4) * 0.06 }}
                data-testid={`service-card-${i}`}
                onClick={onQuoteClick}
                className="relative aspect-square overflow-hidden rounded-3xl border border-gray-200 group cursor-pointer shadow-sm hover:shadow-xl transition-shadow bg-white"
              >
                {img ? (
                  <img
                    src={img}
                    alt={s.title}
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                ) : (
                  <div className="absolute inset-0 bg-gradient-to-br from-white via-brand-mist to-gray-100 grid place-items-center">
                    <div className="h-20 w-20 rounded-2xl bg-brand-blue/10 grid place-items-center text-brand-blue">
                      <Icon name={s.icon} className="h-10 w-10" />
                    </div>
                  </div>
                )}
                <div className={`absolute inset-0 ${img ? "bg-gradient-to-t from-brand-ink/90 via-brand-ink/20 to-transparent" : "bg-gradient-to-t from-brand-ink/85 via-brand-ink/10 to-transparent"}`} />
                <div className="absolute inset-x-0 bottom-0 p-4 sm:p-5 text-white">
                  <div className="overline text-brand-green text-[10px] sm:text-xs">PPrints</div>
                  <h3 className="mt-1 font-display font-bold text-base sm:text-lg leading-tight line-clamp-2">{s.title}</h3>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
